import videojs from 'video.js'
import 'videojs-mobile-ui/dist/videojs-mobile-ui.css';
import 'videojs-mobile-ui';

// import {Alpine, Livewire} from '../../vendor/livewire/livewire/dist/livewire.esm';
// import ToastComponent from '../../vendor/usernotnull/tall-toasts/resources/js/tall-toasts'
//
// Alpine.plugin(ToastComponent)
//
// Livewire.start()

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'
//
// window.Pusher = require('pusher-js');
//
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     wsHost: window.location.hostname,
//     wsPort: 6001,
//     wssPort: 6001,
//     enabledTransports: ['ws', 'wss'],
//     disableStats: true,
// });


document.addEventListener('livewire:init', function(){
    let video = document.querySelector('#osvideo');
    if (video){
        let player = videojs(video, {
            disablePictureInPicture: true,
            enableDocumentPictureInPicture: false,
            fullscreen: {
                enterOnRotate: true,
                exitOnRotate: true,
                lockOnRotate: true,
                lockToLandscapeOnEnter: false,
                disabled: false
            },
            touchControls: {
                seekSeconds: 10,
                tapTimeout: 500,
                disableOnEnd: false,
                disabled: false,
            },
        });

        player.mobileUi();
    }


    let videos = document.querySelectorAll('video, .video-js, .video');
    if (videos){
        videos.forEach(function(video){
            video.addEventListener('contextmenu', event => {
                event.preventDefault();
            });
        });
    }

    function noticesHandler() {
        return {
            notices: [],
            visible: [],
            add(notice) {
                notice.id = Date.now()
                this.notices.push(notice)
                this.fire(notice.id)
            },
            fire(id) {
                this.visible.push(this.notices.find(notice => notice.id == id))
                const timeShown = 2000 * this.visible.length
                setTimeout(() => {
                    this.remove(id)
                }, timeShown)
            },
            remove(id) {
                const notice = this.visible.find(notice => notice.id == id)
                const index = this.visible.indexOf(notice)
                this.visible.splice(index, 1)
            },
        }
    }
})



